module.exports = __webpack_public_path__ + "static/media/ovest logo.097c0010.svg";